module.exports = __webpack_public_path__ + "img/info6.7bf6c5f3.png";